// @flow
import ApiClient from './ApiClient';

export default class StockAcquisitionRightClient extends ApiClient {
  updateStockAcquisitionRight = (
    href: string,
    method: string,
    data: Object,
    success: Function,
    error: Function = this.errorHandler,
  ) => {
    this.ajax({
      url: href,
      dataType: 'script',
      type: method,
      data,
      processData: false,
      success,
      error,
    });
  };
}
